import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  Input,
  Button,
  Form,
  Row,
  Col,
  Typography,
  Spin,
} from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { INIT_ADMIN_LOGIN } from '../state/auth/types';
import { RESOURCE } from '../config/constants/alerts';
import Alerts from '../components/alerts/Alerts';
import rutValidator from '../helpers/rutValidator';
import PropTypes from 'prop-types';
import TramittaLogo from '../images/tramitta-logo.png';
import ImgPerson from '../images/img-person.png';

const { Title } = Typography;

/**
 * Component that returns login form.
 * @component
 * @returns {Element} react form.
 */
const Login = (props) => {
  const [loaderSpinning, setLoaderSpinning] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (props.error.status >= 200) {
      setLoaderSpinning(false);
    }
  }, [props.error]);

  /**
   * Function that dispatch user data to login
   * @param {Object} data Object with form data
   */
  const onSubmit = (data) => {
    props.loginUser(data);
    setLoaderSpinning(true);
  };

  return (
    <div className="bg-white bg-login">
      <Spin
        spinning={loaderSpinning}
      >
        <Row>
          <Col
            className="gutter-row mx-auto"
            xs={{ span: 20 }}
            sm={{ span: 12 }}
            lg={{ span: 8 }}
            xl={{ span: 6 }}
          >
            <Alerts />
          </Col>
        </Row>
        <div className="login-container">
          <Row>
            <Col
              className="gutter-row mx-auto login-column"
              xs={{ span: 20 }}
              sm={{ span: 12 }}
            >
              <Row>
                <Col xs={{ span: 20 }} md={{ span: 16 }} lg={{ span: 10 }} className="mx-auto">
                  <img src={TramittaLogo} alt="Tramitta logo" className="logo-login mb-4" />
                  <Title level={4}>Inicia sesión</Title>
                  <Form
                    form={form}
                    className="login-form"
                    onFinish={onSubmit}
                    autoComplete="on"
                  >
                    <Form.Item
                      name="user_name"
                      rules={[
                        ({
                          validator(_, value) {
                            if (value && rutValidator(value)) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              'Debe ingresar un rut válido',
                            );
                          },
                        }),
                        {
                          required: true,
                          message: 'Campo Rut es obligatorio',
                        },
                        {
                          pattern: new RegExp(/^[0-9]+[-|‐]{1}[0-9kK]{1}$/),
                          message: 'Debe ingresar rut con guión'
                        }
                      ]}
                    >
                      <Input
                        prefix={<UserOutlined className="site-form-item-icon" />}
                        placeholder="Ingrese Rut con guión"
                        size="large"
                      />
                    </Form.Item>
                    <Form.Item
                      name="password"
                      rules={[
                        { required: true, message: 'Por favor ingrese su contraseña' },
                      ]}
                    >
                      <Input.Password
                        prefix={<LockOutlined className="site-form-item-icon" />}
                        type="password"
                        placeholder="Contraseña"
                        size="large"
                      />
                    </Form.Item>
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="login-form-button"
                        size="large"
                      >
                        Ingresar
                      </Button>
                    </Form.Item>
                  </Form>
                </Col>
              </Row>
            </Col>
            <Col sm={{ span: 12 }} className="img-column">
              <Row>
                <Col md={{ span: 14 }}>
                  <Title level={2}>Tus documentos electrónicos en un solo lugar. </Title>
                </Col>
              </Row>
              <img src={ImgPerson} alt="" className="img-person" />
            </Col>
          </Row>
        </div>
      </Spin>
    </div>
  );
};

Login.propTypes = {
  /**
   * Object with error code and status
   */
  error: PropTypes.object.isRequired,
  /**
 * Function that dispatch data from form
 */
  loginUser: PropTypes.func.isRequired,
};

const data = (state) => ({
  error: state.error,
});

const actions = (dispatch) => ({
  loginUser: (data) =>
    dispatch({
      type: INIT_ADMIN_LOGIN,
      payload: { ...data, resource: RESOURCE.ADMIN_LOGIN },
    }),
});

export default connect(data, actions)(Login);